import React, { useEffect, useState } from "react";

import { ShieldHalf } from "lucide-react";

import {
  clearSimulatedAccess,
  simulatedAccess,
  simulatingMinutesLeft,
} from "@/util";
import { StatusStrip, StatusStripButton } from "@/components/StatusStrip";

export const SimulatePermissionsBar: React.FC = () => {
  const sim = simulatedAccess();
  const [minutesLeft, setMinutesLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setMinutesLeft(simulatingMinutesLeft() ?? 0);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!sim) {
    return null;
  }

  return (
    <StatusStrip
      tone="simulate-permissions"
      label="Simulated permissions"
      icon={<ShieldHalf size={16} aria-hidden className="shrink-0" />}
    >
      <span className="min-w-0 flex-1 truncate">
        Simulating a restricted permission set
        {sim.backendOnly ? " on the backend only (UI unrestricted)" : ""}.{" "}
        {minutesLeft > 0 && `${minutesLeft} minutes left.`}
      </span>
      <StatusStripButton
        tone="simulate-permissions"
        onClick={() => {
          clearSimulatedAccess();
          window.location.reload();
        }}
        title="Stop simulating"
      >
        Stop
      </StatusStripButton>
    </StatusStrip>
  );
};
